import { PenaltyEntity } from './penalty-entity';
import { ScheduleRowEntity } from '../schedule/schedule-row-entity';

export class SchedulerResponseEntity {

    public static fromDto(dto: any): SchedulerResponseEntity {
        if (!dto) {
            return new SchedulerResponseEntity();
        }
        const entity = new SchedulerResponseEntity();
        entity.penalty = PenaltyEntity.fromDto(dto.penalty);
        entity.games = ScheduleRowEntity.fromDtoArray(dto.games);
        return entity;
    }

    public static fromDtoArray(dtoArray: any[]): SchedulerResponseEntity[] {
        const entities: SchedulerResponseEntity[] = [];
        if (!dtoArray) {
            return entities;
        }
        for (const dto of dtoArray) {
            const entity = SchedulerResponseEntity.fromDto(dto);
            entities.push(entity);
        }
        return entities;
    }

    public penalty: PenaltyEntity = null;
    public games: ScheduleRowEntity[] = null;

}
